



























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

// 带 tooltip 的图标按钮
@Component
export default class TooltipIcon extends Vue {
  @Prop() public msg!: string;
  @Prop() public cls!: string;
  @Prop() public icon!: string;
  @Prop() public width!: number;
  @Prop() public btnColor!: string;
  @Prop() public iconColor!: string;
  @Prop() public iconSize!: string;
  @Prop() public href!: string;   // 链接的跳转地址
  @Prop() public target!: string; // 是否新标签页打开, 可选值: '_blank'
  @Prop({ type: Boolean, default: false }) public hidden!: boolean;  // 隐藏图标, 禁用按钮，保留占用的位置
  @Prop({ type: Boolean, default: false }) public large!: boolean;
  @Prop({ type: Boolean, default: false }) public hideTip!: boolean;
  @Prop({ type: Boolean, default: false }) public loading!: boolean;
  @Prop({ type: Boolean, default: false }) public disabled!: boolean;

  public get disBtn() {
    return this.disabled || this.hidden || this.loading;
  }

  public get isSmall() {
    return this.iconSize ? null : !this.large;
  }

  @Emit('click')
  public onClick() {
    return;
  }
}
